module.exports = __webpack_public_path__ + "assets/img/index-zw2.05a60745.png";